import { smartDocParamType_External } from './external/index.js';
import { smartDocParamType_Dynamic } from './dynamic/index.js';
import { smartDocParamType_Static } from './static/index.js';
import { smartDocParamType_EHR } from './ehr/index.js';
export const smartDocParamTypes = [smartDocParamType_Static, smartDocParamType_Dynamic, smartDocParamType_External, smartDocParamType_EHR];
export const smartDocStaticParamType_Time = 'time';
//# sourceMappingURL=types.js.map